export const makeDraftKeyFromId = (replyId, keyPrefix) => `${keyPrefix}_${replyId}`;